import { Typography } from 'antd'
import styled from 'styled-components'

const StyledAllocatedUserLabel = styled(Typography.Text)`
  display: block;
`

export default StyledAllocatedUserLabel
